import moment from 'moment'

export default class ObjectMapper {

    static map (source, clazz, fields, ignoreCheckFields = []) {
        if (typeof source !== 'object') {
            throw new Error('cannot map non-object.')
        }
        if (typeof clazz !== 'string') {
            throw new Error('cannot map without a class name.')
        }
        if (!(fields instanceof Array)) {
            throw new Error('cannot map without fields list.')
        }

        const target = {}
        for (const field of fields) {
            const fieldName = field.name
            let fieldValue = null

            if (ignoreCheckFields.indexOf(fieldName) === -1) {
                // Required field missing?
                if (typeof field.required === 'boolean' && field.required && typeof source[fieldName] === 'undefined') {
                    throw new Error(`missing required field '${fieldName}' for type '${clazz}'.`)
                }

                // Valid field value?
                fieldValue = typeof source[fieldName] === 'undefined' ? null : source[fieldName]
                if (typeof field.check !== 'undefined' && !field.check(fieldValue)) {
                    throw new Error(`invalid value '${fieldValue}' for field '${fieldName}' of type '${clazz}'.`)
                }
            }

            // Assign, optionally converted, value
            if (typeof field.convert !== 'undefined') {
                try {
                    target[fieldName] = field.convert(fieldValue)
                } catch (err) {
                    throw new Error(`failed to convert value '${fieldValue}' for field '${fieldName}' of type '${clazz}': ${err}`)
                }
            } else {
                target[fieldName] = typeof fieldValue === 'undefined' ? null : fieldValue
            }
        }

        return target
    }

    static checkUuid (v) {
        return ObjectMapper.checkNonEmptyString(v)
    }

    static checkNonEmptyString (v) {
        return typeof v === 'string' && v.trim() !== ''
    }

    static checkNumberInterval (v, min, max) {
        let real = typeof v === 'number' ? v : parseInt(v)
        return real >= min && real <= max
    }

    static checkNumber (v) {
        return typeof v === 'number' ? true : !isNaN(v)
    }

    static checkBooleanInteger (v) {
        return ObjectMapper.checkNumberInterval(v, 0, 1)
    }

}